import React from "react";
import { Select, MenuItem } from "@mui/material";
import { buildAdminMonthOptions } from "../../utils/adminMonthFilter";

export const ADMIN_MONTH_OPTIONS = buildAdminMonthOptions();

export const adminMonthSelectSx = {
  height: 38,
  minWidth: 180,
  fontSize: "13px",
  background: "#fff",
  ".MuiOutlinedInput-notchedOutline": {
    borderColor: "#dbe2ea",
  },
};

export default function AdminMonthSelect({
  value,
  onChange,
  options = ADMIN_MONTH_OPTIONS,
  includeAll = true,
  sx,
  ...rest
}) {
  return (
    <Select
      size="small"
      value={value}
      onChange={onChange}
      displayEmpty
      sx={{ ...adminMonthSelectSx, ...sx }}
      {...rest}
    >
      {includeAll && <MenuItem value="">All Months</MenuItem>}
      {options.map((item) => (
        <MenuItem key={item.value} value={item.value}>
          {item.label}
        </MenuItem>
      ))}
    </Select>
  );
}

export function normalizeVoteRow(row) {
  if (!row) return row;
  return {
    ...row,
    totalVotes: Number(row.totalVotes) || 0,
    totalVideos: Number(row.totalVideos) || 0,
  };
}

export function normalizeVoteRows(rows) {
  return (rows || []).map(normalizeVoteRow);
}
